export enum StatusVisit {
    None = 0,
    InscriptionOk = 1,
    InscriptionFull = 2,
}
